<div #loadingSplash>
  <div class="loading-splash">
    <img src="./assets/login-logo.png" width="250px" alt="BRNKL logo" style="padding-bottom: 20px"/>
    <ion-spinner name="crescent" class="loading-spinner"></ion-spinner>
    <p>Loading...</p>
  </div>
</div>
